const pathRouts = {
    HOME: 'home',
    MESSAGES: "messages",
    DASHBOARD: "dashboard",
    CALENDAR: "calendar",
    TEACHERROOM: "teacherRoom",
    MYLEARNING: "myLearning",
    MYCLASSES:"myClasses",
    MYLEARNINGDOMAIN: "myLearning/domain/:domainId",
    DISCOVERY: "discovery",
    PLUSLEARNING: "plusLearning",
    USEFULTOOLS: "usefulTools",
    BGT: "bgt",
    DELAYNAVIGATE: "delayNavigate",
    REALISTICISRAEL: "realisticIsrael",
    ARCHIVE: "archive",
    DOMAIN: "domain",
    PROFFESSIONALDEVELOPMENT:"professionalDevelopment",
    FINALPROJECTS: "finalProjects",
    ASSIGNSTUDYGTOUP:"assignStudyGroup",
    GOOGLEMEET: "googleMeet",
    LOGOANDIMAGE: "logoAndImage",
    ROLEHOLDERS: "rolePermissions",
    TOOLSPAGE: "toolsPage",
    MANAGERDASHBOARD: "managerDashboard",
    SYSTEMMESSAGES: "systemMessages",
    BOT: "chatbots"
};

export default pathRouts;